/**
 * Numbering follows the boxes on the ICS 202-CG form, as printed by
 * `services/coms/src/routes/Forms/ICS_CG/forms/ICS202CG.ts`.
 *
 * Boxes 1 to 3 are read-only on the card; 4-9 and 11-13 are editable. Boxes 10
 * and 14 are the same signature reprinted on page 3, so the card shows it once
 * under a label naming both.
 */
export const ICS202_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  communityLifelines: '4. Community Lifelines:',
  priorities: '5. Incident Priorities:',
  objectives: '6. Incident Objectives:',
  commandEmphasis:
    '7. Operational Period Command Emphasis: (Safety, Direction)',
  siteSafetyPlanRequired: '8. Site Safety Plan Required:',
  siteSafetyPlanLocation: '9. Site Safety Plan located at:',
  criticalInformationRequirements: '11. Critical Information Requirements:',
  limitationsAndConstraints: '12. Limitations and Constraints:',
  keyDecisionsAndProcedures: '13. Key Decisions and Procedures:',
  preparedBy: '10 & 14. Prepared by:',
} as const;

/** Fixed choices printed for box 4. Custom lifelines are not part of the form. */
export const COMMUNITY_LIFELINES = [
  'Safety and Security',
  'Transportation',
  'Hazardous Materials',
  'Health and Medical',
  'Energy',
  'Communications',
  'Food, Hydration, Shelter',
  'Water Systems',
] as const;

/**
 * Box 3 holds the planned next operational period rather than the current one,
 * which is not obvious from the printed label.
 */
export const ICS202_OPERATIONAL_PERIOD_HINT =
  'Click this box to set the scheduled start and end of the next operational period for this incident workspace. Working-period forms print that window. The period itself is advanced within the Operations Briefing phase.';

export const ICS202_INCIDENT_NAME_HINT =
  'This box is read-only. It is filled from the incident name.';

/** Mirrors `resolveOperationalPeriodValues`, which the PDF export uses. */
export const ICS202_INCIDENT_LOCATION_HINT =
  'This box is read-only. It is filled from the incident location, falling back to the address set when the incident was created.';
